import React, { ReactNode } from "react";
import { Drawer, Modal } from "antd";
import SheetHeaderClose from "../../v2/components/SheetHeaderClose";

interface Props {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  isMobile: boolean;
  width?: number;
  // Mobile only: fill the screen instead of hugging the content (the Figma "Tour Tier" sheet).
  fullScreen?: boolean;
  className?: string;
  children: ReactNode;
}

// Shared "view all" popup pattern used across the page's 4 modals: a Modal on
// desktop, a bottom Drawer on mobile - mirrors pages/gd/v2/components/FiltersPanel.
export default function GroundTourModal({ open, onClose, title, isMobile, width = 560, fullScreen, className, children }: Props) {
  if (isMobile) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        placement="bottom"
        height={fullScreen ? "100%" : "auto"}
        title={title}
        closable={false}
        extra={<SheetHeaderClose onClose={onClose} />}
        rootClassName={["v2-sheet ground-tour-show-v2__sheet", className].filter(Boolean).join(" ")}
      >
        {children}
      </Drawer>
    );
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      width={width}
      centered
      footer={null}
      rootClassName={["ground-tour-show-v2__modal", className].filter(Boolean).join(" ")}
    >
      {children}
    </Modal>
  );
}
